/**
 * Swiper carousel
 * https://swiperjs.com/
 */

// import Swiper and modules styles
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, A11y, EffectFade } from 'swiper/modules';
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import 'swiper/css/keyboard'
import 'swiper/css/a11y';

export function swiper() {
  if (jQuery(".swiper").length === 0) {
    return;
  }

  function initSwipers(defaults = {}, selector = ".swiper") {
    let swipers = document.querySelectorAll(selector);
  
    swipers.forEach((swiperContainer, index) => {
      // Create a unique class name for the swiper container
      let swiperClass = 'swiper-' + index;
  
      // Add the unique class to the swiper container if not already added
      if (!swiperContainer.classList.contains(swiperClass)) {
        swiperContainer.classList.add(swiperClass);
  
        // Get options
        let optionsData = swiperContainer.dataset.swiper
          ? JSON.parse(swiperContainer.dataset.swiper)
          : {};

        // Get dottext from data attribute
        let dottext = swiperContainer.getAttribute('data-dottext') || 'Gå til slide #';

        // Check if the swiper should be active only on mobile
        let shouldEnableSwiper = optionsData.mobileOnly && window.innerWidth <= 768;

        // Combine defaults and custom options
        let options = {
          ...defaults,
          ...optionsData,
          navigation: {
            nextEl: swiperContainer.querySelector('.swiper-button-next'),
            prevEl: swiperContainer.querySelector('.swiper-button-prev'),
          }, // Set navigation options specific to this swiper
          pagination: {
            ...defaults.pagination,
            el: swiperContainer.querySelector('.swiper-pagination'),
            renderBullet: function (index, className) {
              let ariaLabel = dottext.replace('#', index + 1);
              // swiper-pagination-bullet class is on <button>, not <li>
              // Swiper's A11y manages tabindex on the button only — <li> is never focusable
              return `<li><button type="button" class="${className}" aria-label="${ariaLabel}"></button></li>`;
            },
          },
        };

        // Initialize Swiper only if it should be active on the current device
        if (!optionsData.mobileOnly || shouldEnableSwiper) {

          // Initialize Swiper
          let swiperInstance = new Swiper(swiperContainer, options);

          // Label the pagination container so screen readers announce "Slide-navigation, list, X items"
          const paginationContainer = swiperContainer.querySelector('.swiper-pagination');
          if (paginationContainer && !paginationContainer.getAttribute('aria-label')) {
            paginationContainer.setAttribute('aria-label', 'Slide-navigation');
          }

            // Remove aria-live from swiper-wrapper — Swiper's A11y adds it, but it causes
          // every DOM change inside slides (e.g. lazy images) to be announced unnecessarily.
          const wrapper = swiperContainer.querySelector('.swiper-wrapper');
          if (wrapper) wrapper.removeAttribute('aria-live');

          // Pagination click — Swiper's built-in handler loses track of slide index when
          // renderBullet wraps bullets in <li>. We handle it ourselves.
          const paginationEl = swiperContainer.querySelector('.swiper-pagination');
          if (paginationEl) {
            paginationEl.addEventListener('click', function(e) {
              const btn = e.target.closest('button.swiper-pagination-bullet');
              if (!btn) return;
              const bullets = Array.from(paginationEl.querySelectorAll('button.swiper-pagination-bullet'));
              const index = bullets.indexOf(btn);
              if (index !== -1) swiperInstance.slideToLoop(index);
            });
          }

          // Keyboard activation for prev/next — they are <div role="button"> so browsers
          // do not fire click on Enter/Space automatically.
          ['.swiper-button-prev', '.swiper-button-next'].forEach(sel => {
            const el = swiperContainer.querySelector(sel);
            if (!el) return;
            el.addEventListener('keydown', function(e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                el.click();
              }
            });
          });

          // Status announcement — query notification fresh on each slide change so we are
          // not vulnerable to a null reference if A11y creates the element after init.
          swiperInstance.on('slideChange', function() {
            const notifEl = swiperContainer.querySelector('.swiper-notification');
            if (!notifEl) return;

            // Ensure the region is polite every time (A11y may reset attributes)
            notifEl.setAttribute('role', 'status');
            notifEl.setAttribute('aria-live', 'polite');
            notifEl.setAttribute('aria-atomic', 'true');

            const current = swiperInstance.realIndex + 1;
            const bullets = swiperContainer.querySelectorAll('.swiper-pagination button.swiper-pagination-bullet');
            const total = bullets.length
              || swiperContainer.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;

            // Clear then set — forces screen readers to detect the mutation even when
            // landing on the same slide index via loop wraparound.
            notifEl.textContent = '';
            requestAnimationFrame(() => {
              notifEl.textContent = `Slide ${current} / ${total}`;
            });
          });
        }
      }
    });
  }  

  // Basic options for all sliders
  let defaults = {
    modules: [Navigation, Pagination, Keyboard, A11y, EffectFade],
    slidesPerView: 1,
    spaceBetween: 30,
    autoHeight: false,
    effect: "fade",
    loop: true,
    lazy: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    keyboard: {
      enabled: true,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Forrige slide',
      nextSlideMessage: 'Næste slide',
      firstSlideMessage: 'Dette er det første slide',
      lastSlideMessage: 'Dette er det sidste slide',
      paginationBulletMessage: 'Gå til slide {{index}}',
    },
  };
  
  // Call the init function
  initSwipers(defaults);

}

export default swiper;
